const title = 'Password Generator'
const characterLength = 'Character Length'
export { title, characterLength }
